import './css/top.css';

const Top = () => {
    return(
                <div className="headerTopBar">
                <div className="row nestani">
                  <label className='boja'>Porucite telefonom:</label>
                    <span className="spanTop nestani">
                        <a href="tel:+381616823247" className="ajp">
                            061 682 3247 - Dušan
                        </a>
                    </span>                    
                    <span className="spanTop nestani">
                        <a href="tel:+381644095182" className="ajp">
                            064 409 5182 - Nenad
                        </a>
                    </span>
                </div>
            </div>
    );
}
    export default Top; 